// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'Inter', 'Inter Fallback'","fontStyle":"normal"},"className":"__className_fa2f99"};